import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable()
export class PaginationService {
    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 25) {
        const showPage = 4;
        // calculate total pages
        const totalPages = Math.ceil(totalItems / pageSize);

        let startPage: number, endPage: number;
        if (totalPages <= showPage) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= Math.floor(0.6 * showPage)) {
                startPage = 1;
                endPage = showPage;
            } else if (currentPage + Math.floor(0.4 * showPage) >= totalPages) {
                startPage = totalPages - Math.floor(0.9 * showPage);
                endPage = totalPages;
            } else {
                startPage = currentPage - Math.floor(0.5 * showPage);
                endPage = currentPage + Math.floor(0.4 * showPage);
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        startIndex = Math.max(startIndex, -1);
        endIndex = Math.max(endIndex, -1);
        // create an array of pages to ng-repeat in the pager control
        const pages = _.range(startPage, endPage + 1);

        const currentItems = (pageSize * currentPage) <= totalItems ? pageSize * currentPage : totalItems;
        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages,
            currentItems: currentItems
        };
    }
}
